import { FunctionComponent } from "react";
import { useFilterState } from "modules/filter/hook";
import { Container } from "./attribute-group-tags.styles";
import { filterAddAttribute } from "modules/filter/actions";
import Badge from "components/badge";

interface AttributeGroupTagsProps {
  group: any;
}

const AttributeGroupTags: FunctionComponent<AttributeGroupTagsProps> = ({
  group,
}) => {
  const filterState = useFilterState();
  return (
    <Container>
      {group.attributes.map((attribute: any) => {
        const { selectedAttributes } = filterState;
        let selected = false;

        if (selectedAttributes.includes(attribute.uuid)) selected = true;
        return (
          <Badge
            key={attribute.uuid}
            color="white"
            backgroundColor={selected ? "orange" : ""}
            onClick={() => filterAddAttribute(attribute.uuid)}
          >
            {attribute.name}
          </Badge>
        );
      })}
    </Container>
  );
};

export default AttributeGroupTags;
